<!--
Download screen

TODO: componentize this somehow - lots of repetition in there

@author bmk11u
-->
<template>
  <div id="contain" class="container">
    <Nav name="Sync Calendar"/>
      <main class="subscribemain p-2 pb-4">
      <h1 class="synctitle">Sync Your Calendar</h1>
      <div class="syncinstructions" v-if="device === 'iOS'">
        <p class="disclaimer">For the most up-to-date information and to subscribe to late change alerts, we recommend using the UofG Life App for personalised timetabling services.</p>
        <p>To subscribe to your timetable from your <span class="bluetext">iPhone / iPad calendar</span>:</p>
        <ol>
          <li>Open <span class="bluetext">Settings</span> then open <span class="bluetext">Calendar</span></li>
          <li>Tap on <span class="bluetext">Accounts</span> select <span class="bluetext">Add Account</span> then <span class="bluetext">Other</span></li>
          <li>Under <span class="bluetext">CALENDAR</span> select <span class="bluetext">Add Subscribed Calendar</span></li>
          <li class="url">For Server, enter https://frontdoor.spa.gla.ac.uk/spacett/download/uogtimetable.ics</li>
          <li>Select <span class="bluetext">Next</span></li>
          <li>A Subscription box will appear showing the server address just entered</li>
          <li>Fill in <span class="bluetext">Username</span> with your <span class="bluetext">GUID</span> and then enter your <span class="bluetext">Password</span></li>
          <li>Use <span class="bluetext">SSL</span> ensure this is selected as <span class="bluetext">ON</span></li>
          <li>Select <span class="bluetext">Next</span> and then <span class="bluetext">Save</span></li>
        </ol>
        <p>The web address you entered will now show under <span class="bluetext">Subscribed Calendars</span> within <span class="bluetext">Accounts</span>.</p>
        <p>To view your UofG Timetable now open the Calendar app.</p>
        <hr>
        <div v-bind:key="index" v-for="(dev, index) in allExcept('iOS')">
        <br v-if="index != 0" />
        <a href="JavaScript:void(0)" class="instructionslink" @click="device = dev.name">{{ dev.title }}</a>
        </div>

      </div>

      <div class="syncinstructions" v-if="device === 'Mac'">
        <p class="disclaimer">For the most up-to-date information and to subscribe to late change alerts, we recommend using the UofG Life App for personalised timetabling services.</p>
        <p>To subscribe to your timetable from Apple Calendar:</p>
        <ol>
          <li>In the Calendar app on your Mac, choose <span class="bluetext">File > New Calendar Subscription</span>.</li>
          <li class="url">Enter the calendar web address: https://{{ icsUrl }} then click <span class="bluetext">Subscribe</span></li>
          <li>Enter your credentials into the Authentication box. This must be your UofG GUID and password. Click <span class="bluetext">OK</span>.</li>
          <li>Enter a name for the calendar in the Name field. Then click the adjacent pop-up menu to select a colour for the calendar.</li>
          <li>Click the Location pop-up menu, then choose an account for the subscription. If you choose:
            <ul>
              <li><span class="bluetext">iCloud account</span> - the calendar is available on all your computers and devices that are set up with iCloud.</li>
              <li><span class="bluetext">On My Mac</span> - the calendar is saved on your computer.</li>
            </ul>
          </li>
          <li>Deselect the appropriate tick-boxes to achieve the required calendar event, attachments or alerts</li>
          <li>Click the <span class="bluetext">Auto-refresh</span> pop-up menu, then choose how often to update the calendar.</li>
          <li>To prevent alerts from appearing for this calendar, select <span class="bluetext">Ignore alerts</span>, then click <span class="bluetext">OK</span>.</li>
        </ol>
        If you need to change these settings later, find and click on the name of the calendar you set up then choose <span class="bluetext">Edit > Get Info</span>.
        <hr>
        <div v-bind:key="index" v-for="(dev, index) in allExcept('Mac')">
        <br v-if="index != 0" />
        <a href="JavaScript:void(0)" class="instructionslink" @click="device = dev.name">{{ dev.title }}</a>
        </div>

      </div>

      <div class="syncinstructions" v-if="device === 'Windows'">
        <p class="disclaimer">For the most up-to-date information and to subscribe to late change alerts, we recommend using the UofG Life App for personalised timetabling services.</p>
        <p>You cannot synchronise your University of Glasgow timetable from a browser based version of Outlook 365. Outlook 365 needs to be installed directly on your PC or laptop. </p>
        <p>Please note that whilst there is an option available to synchronise your timetable calendar, it is not always straightforward to add this to Outlook, depending on the device. Please be aware, we would recommend that you do not merge the timetable calendar with any other Outlook calendars as this can cause issues with updating information.</p>
        <p>After installing the desktop version of Outlook 365, sync your timetable calendar as follows:</p>
        <ol>
          <li>Open <span class="bluetext">Microsoft Edge</span> browser</li>
          <li class="url">Paste this URL into the address bar <span class="bluetext">webcals://{{ icsUrl }}</span></li>
          <li>A message advising "This site is trying to open Outlook" will appear, click <span class="bluetext">Open</span></li>
          <li>You will then be prompted with a log in box - enter your <span class="bluetext">GUID</span> and <span class="bluetext">password</span>
          <br/>*Please note - If you are not presented with a log in box, (depending on your laptop or PC) you may need to select "Login with a different account"  You should then be able to enter your GUID and Password to continue.</li>
          <li>A box will appear asking "Add this internet calendar to Outlook and subscribe to updates?" Options are Yes, No or Advanced.</li>
          <li>You can click into <span class="bluetext">Advanced</span> first, enter a <span class="bluetext">Folder Name</span> of <span class="bluetext">UofG Timetable</span>. Leave all other options as they are and click <span class="bluetext">OK</span> to close.</li>
          <li>Then click <span class="bluetext">Yes</span> to add the calendar to Outlook.</li>
        </ol>
        <p>To view your Timetable Calendar:</p>
        <ol>
          <li>Open Outlook, click on the calendar icon</li>
          <li>Go to <span class="bluetext">Other Calendar</span> and tick the checkbox</li>
        </ol>
        <p>You should now see the UofG Timetable calendar.</p>
        <hr>
        <div v-bind:key="index" v-for="(dev, index) in allExcept('Windows')">
        <br v-if="index != 0" />
        <a href="JavaScript:void(0)" class="instructionslink" @click="device = dev.name">{{ dev.title }}</a>
        </div>

      </div>

      <div class="syncinstructions" v-if="device === null || device === 'Other' || device == 'Android'">
        <p class="disclaimer">For the most up-to-date information and to subscribe to late change alerts, we recommend using the UofG Life App for personalised timetabling services.</p>
        <p>On some devices, you can subscribe to view your timetable in your personal calendar.</p>
        <p v-if="device == 'Android'" class="list-group-item list-group-item-info mb-2">
          You can also install 3rd party apps to add .ics support to your Android device.
          Students have recommended ICSSync and CalDav-Sync, that come at a small cost but these will be used at your risk.
        </p>
        <ol>
          <li class="url">Point your calendar application to <span class="bluetext">https://{{ icsUrl }}</span></li>
          <li>Specify your <span class="bluetext">GUID</span> and <span class="bluetext">password</span></li>
          <li>Refresh no more than every 5 minutes</li>
        </ol>
        <hr>
        <div v-bind:key="index" v-for="(dev, index) in allExcept('Android')">
        <br v-if="index != 0" />
        <a href="JavaScript:void(0)" class="instructionslink" @click="device = dev.name">{{ dev.title }}</a>
        </div>

      </div>
    </main>
    <div id="pusher"></div>
      <Footer active="download"/>
      <CopyComplete item="server address" />
  </div>
</template>

<script setup>
//Utilities
import { ref, onMounted } from 'vue'
import $ from 'jquery'
import ClipboardJS from 'clipboard'

//Composables
import { useDeviceType } from '@/composables/DeviceCommon.js'
const os = useDeviceType()

//Components
import CopyComplete from '@/components/CopyComplete.vue'
import Footer from '@/components/FooterMenu.vue'

//Data
const devices =  ref([
  { name: 'iOS', title: 'View iPhone / iPad instructions' },
  { name: 'Mac', title: 'View Mac instructions' },
  { name: 'Windows', title: 'View Outlook 365 (desktop) instructions' },
  { name: 'Android', title: 'View Android instructions' }
])
const device =  ref(null)
const icsUrl =  ref('frontdoor.spa.gla.ac.uk/spacett/download/uogtimetable.ics')
const clipboardAvailable =  ref(ClipboardJS.isSupported())

onMounted(
  () => {
    device.value = os.value
  }
)

function copyUrl (icsProtocol) {
  copyText(icsProtocol + icsUrl.value)
  $('#copyCompleteModal').modal('show')
}

function allExcept (devName) {
    return devices.value.filter(d => d.name != devName)
}

</script>

<style lang='scss'>
.url {
  word-wrap: break-word;
}
.disclaimer {
  border: 1px solid #4F5961;
  padding: 4px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 6px;
}

.syncinstructions {
  padding: 4px;
}
.subscribemain {
  font-size: 18px;
  color: #4F5961;
  line-height: 24px;
  margin-left: 8px;
}

.synctitle {
  color: #003865;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  padding-top: 16px;
  padding-bottom: 8px;
}

.bluetext {
  color: #003865;
  font-weight: 700;
}

.instructionslink {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  color: #003865;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
